import { render, staticRenderFns } from "./SufficientCard.vue?vue&type=template&id=f20385fa&"
import script from "./SufficientCard.vue?vue&type=script&lang=js&"
export * from "./SufficientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports